

import createHistory from 'history/createBrowserHistory';

import App from './components/app';
import './css/main.css';
import './css/fonts.css';
import './css/reset.css';  

const getProps = () => {
		const history = createHistory();
		return { history };
	},
	props = getProps(),
	Entry = () => (<App {...props} />);


export default Entry;



// WEBPACK FOOTER //
// ./index.js